import { render, staticRenderFns } from "./hetong-fujian.vue?vue&type=template&id=ccac80d6"
import script from "./hetong-fujian.vue?vue&type=script&lang=js"
export * from "./hetong-fujian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports